/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IEventOrChallengeOrMilestone {
  Event = 'event',
  Challenge = 'challenge',
  Milestone = 'milestone',
}
